module.exports = __webpack_public_path__ + "img/72.7166b7a5.png";